import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from "@angular/forms";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { Ng4LoadingSpinnerModule } from "ng4-loading-spinner";
import { MatDialogModule } from "@angular/material";
import { BrowserAnimationsModule  } from "@angular/platform-browser/animations";
import {NgxPaginationModule} from 'ngx-pagination';
import { DatePipe } from '@angular/common';
//import { PdfViewerModule } from 'ng2-pdf-viewer';

import { RouteModule } from "./app.route";
import { AppComponent } from './app.component';
import { AddDevoteeComponent } from './admin/components/add-devotee/add-devotee.component';
import { DevoteeService } from "./devotee/devotee.service";
import { SharedService } from "./shared/shared.service";
import { ActionStatusService } from "./shared/action-status.service";
import { DevoteeListComponent } from './admin/components/devotee-list/devotee-list.component';
import { AdminHomeComponent } from './admin/components/admin-home/admin-home.component';
import { DevoteeLoginComponent } from './devotee/devotee-login/devotee-login.component';
import { DevoteeHomeComponent } from './devotee/devotee-home/devotee-home.component';
import { DevoteeProfileComponent } from './devotee/devotee-profile/devotee-profile.component';
import { DevoteeMessageForAdminComponent } from './devotee/devotee-message-for-admin/devotee-message-for-admin.component';
import { DevoteeRegistationComponent } from './devotee/devotee-registation/devotee-registation.component';
import { NotificationComponent } from './admin/notification/notification.component';
import { DevoteeDashboardComponent } from './devotee/devotee-dashboard/devotee-dashboard.component';
import { ComingSoonComponent } from './devotee/coming-soon/coming-soon.component';
import { PujaPrasadComponent } from './prasad-order/puja-prasad/puja-prasad.component';
import { PujaPrasadOrderComponent } from './prasad-order/puja-prasad-order/puja-prasad-order.component';
import { GallaryComponent } from './devotee-module/components/gallary/gallary.component';
import { DevoteeAddressPrintComponent } from './admin/components/devotee-address-print/devotee-address-print.component';
import { DevoteeAddressPrint2Component } from './admin/components/devotee-address-print2/devotee-address-print2.component';
import { TrimPipe } from './admin/pipes/trim.pipe';
import { DasaraFestivalComponent } from './devotee/dasara-festival/dasara-festival.component';
import { AddressConfirmDialogComponent } from './prasad-order/address-confirm-dialog/address-confirm-dialog.component';
import { AdminPujaPrasadOrderComponent } from './admin/components/admin-puja-prasad-order/admin-puja-prasad-order.component';
import { PrasadOrderListComponent } from './admin/components/prasad-order-list/prasad-order-list.component';
import { TodaysPujaComponent } from './admin/components/todays-puja/todays-puja.component';
import { AdminLoginComponent } from './admin/components/admin-login/admin-login.component';
import { PoDispatchComponent } from './admin/components/po-dispatch/po-dispatch.component';
import { PoByPaymentModeComponent } from './admin/components/po-by-payment-mode/po-by-payment-mode.component';
import { SerialkeyComponent } from './devotee/serialkey/serialkey.component';
import { YoutubeComponent } from './devotee/youtube/youtube.component';
import { AdminDevoteeAddressPrintComponent } from './admin/components/admin-devotee-address-print/admin-devotee-address-print.component';
import { PrasadOrderReportComponent } from './admin/components/prasad-order-report/prasad-order-report.component';
import { PostOfficeReportComponent } from './admin/components/post-office-report/post-office-report.component';
import { AboutUsComponent } from './devotee/about-us/about-us.component';
import { ContactUsComponent } from './devotee/contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './devotee/privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './devotee/terms-conditions/terms-conditions.component';
import { MobileAppRedirectComponent } from './devotee/mobile-app-redirect/mobile-app-redirect.component';
import { ShippingPolicyComponent } from './devotee/shipping-policy/shipping-policy.component';
import { AuthInterceptor } from './shared/auth.interceptor';
import { ResponseInterceptor } from './shared/response.interceptor';
import { RazorpayService } from './prasad-order/razorpay.service';
import { MyPujaPrasadOrderComponent } from './prasad-order/my-puja-prasad-order/my-puja-prasad-order.component';
//import { PoAddressPrintComponent } from './admin/components/po-address-print/po-address-print.component';


@NgModule({
  declarations: [
    AppComponent,
    AddDevoteeComponent,
    DevoteeListComponent,
    AdminHomeComponent,
    DevoteeLoginComponent,
    DevoteeHomeComponent,
    DevoteeProfileComponent,
    DevoteeMessageForAdminComponent,
    DevoteeRegistationComponent,
    NotificationComponent,
    DevoteeDashboardComponent,
    ComingSoonComponent,
    PujaPrasadComponent,
    PujaPrasadOrderComponent,
    GallaryComponent,
    DevoteeAddressPrintComponent,
    DevoteeAddressPrint2Component,
    TrimPipe,
    DasaraFestivalComponent,
    AddressConfirmDialogComponent,
    AdminPujaPrasadOrderComponent,
    PrasadOrderListComponent,
    TodaysPujaComponent,
    AdminLoginComponent,
    PoDispatchComponent,
    PoByPaymentModeComponent,
    SerialkeyComponent,
    YoutubeComponent,
    AdminDevoteeAddressPrintComponent,
    PrasadOrderReportComponent,
    PostOfficeReportComponent,
    AboutUsComponent,
    ContactUsComponent,
    PrivacyPolicyComponent,
    TermsConditionsComponent,
    MobileAppRedirectComponent,
    ShippingPolicyComponent,
    MyPujaPrasadOrderComponent
  ],
  imports: [
    BrowserModule,
    RouteModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    Ng4LoadingSpinnerModule.forRoot(),
    BrowserAnimationsModule,
    MatDialogModule,
    NgxPaginationModule
  ],
  entryComponents: [
        DevoteeMessageForAdminComponent,
        AddressConfirmDialogComponent
    ],
  providers: [
    {provide : HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi   : true }, 
    { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
    SharedService,DevoteeService,ActionStatusService,DatePipe, RazorpayService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts